(() => {
  if (customElements.get('customer-video-testimonials')) return;

  class CustomerVideoTestimonials extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.viewport = this.querySelector('[data-customer-video-viewport]');
      this.cards = Array.from(this.querySelectorAll('[data-customer-video-card]'));
      this.paginationItems = Array.from(this.querySelectorAll('[data-customer-video-page]'));

      this.cards.forEach((card) => this.setupCard(card));

      if (this.viewport && this.paginationItems.length > 1) {
        this.rafId = null;
        this.viewport.addEventListener('scroll', () => {
          if (this.rafId) return;
          this.rafId = requestAnimationFrame(() => {
            this.rafId = null;
            this.updatePagination();
          });
        }, { passive: true });
      }
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    setupCard(card) {
      const video = card.querySelector('[data-customer-video]');
      const toggle = card.querySelector('[data-customer-video-toggle]');
      const duration = card.querySelector('[data-customer-video-duration]');

      if (!video || !toggle) return;

      const customerLabel = card.getAttribute('aria-label') || 'Kundenvideo';
      const updateDuration = () => {
        if (!duration || !Number.isFinite(video.duration) || video.duration <= 0) return;
        duration.textContent = this.formatDuration(video.duration);
        duration.classList.add('has-duration');
      };

      const setPlaying = (isPlaying) => {
        card.dataset.playing = String(isPlaying);
        toggle.setAttribute('aria-label', `${customerLabel} ${isPlaying ? 'pausieren' : 'abspielen'}`);
      };

      toggle.addEventListener('click', async () => {
        if (video.paused) {
          this.pauseOtherVideos(video);
          try {
            await video.play();
          } catch (error) {
            setPlaying(false);
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener('loadedmetadata', updateDuration);
      video.addEventListener('durationchange', updateDuration);
      video.addEventListener('play', () => setPlaying(true));
      video.addEventListener('pause', () => setPlaying(false));
      video.addEventListener('ended', () => setPlaying(false));

      if (video.readyState >= 1) updateDuration();
    }

    pauseOtherVideos(activeVideo) {
      this.querySelectorAll('[data-customer-video]').forEach((video) => {
        if (video !== activeVideo && !video.paused) video.pause();
      });
    }

    updatePagination() {
      if (!this.viewport || !this.cards.length) return;

      const viewportLeft = this.viewport.getBoundingClientRect().left;
      let activeIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft - 22);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.paginationItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });
    }

    formatDuration(seconds) {
      const totalSeconds = Math.round(seconds);
      const minutes = Math.floor(totalSeconds / 60);
      const remainder = String(totalSeconds % 60).padStart(2, '0');
      return `${minutes}:${remainder}`;
    }
  }

  customElements.define('customer-video-testimonials', CustomerVideoTestimonials);
})();
